/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: It-service
 * Page name: ItService Page
 * Page Description: This is the IT service page of the website of Ekathva Innovations, it consists of all the
 * brief IT service provided by the company.
 */

import React, { Component } from "react";

import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { Card, Media, Row, Col, Image, Button, Modal } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Navbar from "components/Navbars/Navbar";
import LandingPageIT from "components/Headers/LandingPageIT";
import Footer from "components/Footers/Footer";

import { Formik, Form } from "formik";
import { Input } from "reactstrap";
import Validation from "../Validation.js";
import ApiService from "../api/ApiService.js";

import "assets/style/Style.css";
import successImage from "assets/images/AllPage/list.png";
import failureImage from "assets/images/AllPage/into.png";
import data from "../api/json/itTechnologies.json";

//Bookmarks
import "views/SuccessStoriesPage";
import { ReactComponent as Plus } from "assets/images/AllPage/Plus.svg";
//Icon
import { ReactComponent as IT1 } from "assets/images/ItService/IT1.svg";
import { ReactComponent as IT2 } from "assets/images/ItService/IT2.svg";
import { ReactComponent as IT3 } from "assets/images/ItService/IT3.svg";
import { ReactComponent as IT4 } from "assets/images/ItService/IT4.svg";
import { ReactComponent as IT5 } from "assets/images/ItService/IT5.svg";
import { ReactComponent as IT6 } from "assets/images/ItService/IT6.svg";
import { ReactComponent as IT7 } from "assets/images/ItService/IT7.svg";

import successData from "../api/json/itSuccess.json";
import ItTechnologies from "views/ItTechnologies";
import ItSuccessStories from "./ItSuccessStories.js";

class ItServicePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_project: false,
      modal_success: false,
      modal_failure: false,
      name: "",
      projectTitle: "",
      emailAddress: "",
      contactNumber: "",
      organizationName: "",
      city: "",
      requirement: "",
    };

    this.onProjectSubmit = this.onProjectSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // this is needed, because InfiniteCalendar forces window scroll
    window.scrollTo(0, 0);
  }

  toggle = (modalType) => () => {
    console.log("inside toggle");
    if (!modalType) {
      return this.setState({ modal: !this.state.modal });
    }
    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  }

  onKeyPressTextOnly(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressTextOnly(event);
    }
  }
  onKeyPressNumberOnly(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressNumberOnly(event);
    }
  }
  onKeyPressRetrisctSomeSC(event) {
    if (event.charCode !== 32) {
      Validation.onKeyPressRetrisctSomeSC(event);
    }
  }

  camelCaseString(string) {
    let words = string.trim().split(" ");

    let result = "";

    for (let i = 0; i < words.length; i++) {
      if (words[i] !== "") {
        result =
          result +
          " " +
          words[i][0].toUpperCase() +
          words[i].substring(1).toLowerCase();
      }
    }

    return result;
  }

  onProjectSubmit(values) {
    console.log(values);

    let fields = {
      name: this.camelCaseString(values.name),
      projectTitle: this.camelCaseString(values.projectTitle),
      emailAddress: values.emailAddress,
      contactNumber: values.contactNumber,
      organizationName: this.camelCaseString(values.organizationName),
      city: this.camelCaseString(values.city),
      requirement: values.requirement,
    };

    ApiService.createProject(fields)
      .then((response) => {
        this.setState({
          modal_project: !this.state.modal_project,
          modal_success: !this.state.modal_success,
          message:
            "We have received your Requirement! We will get back to you soon.",
        });
      })
      .catch((error) => {
        this.setState({
          modal_project: !this.state.modal_project,
          modal_failure: !this.state.modal_failure,
          message: "Something Went Wrong! Please Try Again",
        });
      });
  }

  render() {
    let {
      name,
      projectTitle,
      emailAddress,
      contactNumber,
      organizationName,
      city,
      requirement,
    } = this.state;
    return (
      <div>
        <MetaTags>
          <title>
            Website Development, Mobile App development, Enterprise Softwares in
            Shivamogga | Ekathva Innovations Pvt Ltd
          </title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          ></meta>
        </MetaTags>

        <Navbar />
        <LandingPageIT />
        <br />

        <div className="homepage_spacing">
          <div>
            <br />
            <Row>
              <Col md={5}>
                <div className="it_listdisplay">
                  <Row>
                    <Col>
                      <Media data-aos="fade-right">
                        <IT1 className="align-self-start mr-3 svgcolor it_listlogosize" />
                        <Media.Body>
                          <p>
                            <strong>Android / iOS App Development</strong>
                          </p>
                        </Media.Body>
                      </Media>
                      <br />
                      <Media data-aos="fade-right">
                        <IT2 className="align-self-start mr-3 svgcolor it_listlogosize" />
                        <Media.Body>
                          <p>
                            <strong>Web Application Development</strong>
                          </p>
                        </Media.Body>
                      </Media>
                      <br />
                      <Media data-aos="fade-right">
                        <IT3 className="align-self-start mr-3 svgcolor it_listlogosize" />
                        <Media.Body>
                          <p>
                            <strong>Web Design and Development</strong>
                          </p>
                        </Media.Body>
                      </Media>
                      <br />
                      <Media data-aos="fade-right">
                        <IT4 className="align-self-start mr-3 svgcolor it_listlogosize" />
                        <Media.Body>
                          <p>
                            <strong>Domain Registration and Hosting</strong>
                          </p>
                        </Media.Body>
                      </Media>
                      <br />
                      <Media data-aos="fade-right">
                        <IT5 className="align-self-start mr-3 svgcolor it_listlogosize" />
                        <Media.Body>
                          <p>
                            <strong>Software Development</strong>
                          </p>
                        </Media.Body>
                      </Media>
                      <br />
                      <Media data-aos="fade-right">
                        <IT6 className="align-self-start mr-3 svgcolor it_listlogosize" />
                        <Media.Body>
                          <p>
                            <strong>SEO and Digital Marketing</strong>
                          </p>
                        </Media.Body>
                      </Media>
                      <br />
                      <Media data-aos="fade-right">
                        <IT7 className="align-self-start mr-3 svgcolor it_listlogosize" />
                        <Media.Body>
                          <p>
                            <strong>Logo and other Design Services</strong>
                          </p>
                        </Media.Body>
                      </Media>
                    </Col>
                  </Row>
                </div>
                <br />
                <br />
                <br />
                <h5>
                  <span className="aboutus_fontbold"> Technologies </span>we
                  work with{" "}
                  <Link to="/Technologies">
                    <Plus class="rounded mx-auto homepage_plussize" />
                  </Link>
                </h5>
                <div data-aos="zoom-in" className="it_techspacing">
                  <ItTechnologies data={data} />
                </div>
              </Col>

              <Col data-aos="fade-left" md={7}>
                <p>
                  <strong>
                    Ekathva Innovations offers a wide range of services in the
                    area of application development and Information Technology.
                    We deliver services from poster designing to web designing
                    with our expertise in the field of information technology
                    and digitalizing the businesses through Website Design and
                    Development, Android / iOS App Development,
                    Customized/Enterprise software development, Domain
                    Registration, and Hosting, Logo Design and other marketing
                    designs.
                  </strong>
                </p>
                <p>
                  <strong>
                    As of today, we have served more than 45+ satisfied clients
                    through our Design and Development expertise. Our expertise
                    has enabled us to create smart, responsive websites and
                    applications for almost all various businesses out there in
                    the market.
                  </strong>
                </p>
                <br />

                <div className="it_listdisplay1">
                  <ul>
                    <li>
                      <p className="aboutus_fontbold">
                        Android/ Ios App Development
                      </p>
                    </li>
                    <li>
                      <p className="aboutus_fontbold">
                        Website Applicaton Development
                      </p>
                    </li>
                    <li>
                      <p className="aboutus_fontbold">
                        Website Design and Development
                      </p>
                    </li>
                    <li>
                      <p className="aboutus_fontbold">
                        Domain Registration and Hosting
                      </p>
                    </li>
                    <li>
                      <p className="aboutus_fontbold">Software Development</p>
                    </li>
                    <li>
                      <p className="aboutus_fontbold">
                        SEO and Digital Marketing
                      </p>
                    </li>
                    <li>
                      <p className="aboutus_fontbold">
                        Logo and other Design Services
                      </p>
                    </li>
                  </ul>
                </div>

                <br />
                <br />
              </Col>
            </Row>
          </div>
          <hr />
        </div>
        <br />

        {/* <div className="aboutus_mainspace">
          <Row>
            <Col>
              <Card>
                <div className="embedded_projectspacing">
                  <h4>
                    {" "}
                    <span className="aboutus_fontbold">Let's Work</span>{" "}
                    Together
                  </h4>
                  <p>
                    <strong>
                      If you have an idea/requirement and you feel we can serve
                      you, please let us know.
                    </strong>
                  </p>
                  <div className="it_project_buttonalign">
                    <Link
                      onClick={this.toggle("project")}
                      class="cta"
                      style={{ textDecoration: "none" }}
                    >
                      <span>Start a Project</span>
                      <svg width="13px" height="10px" viewBox="0 0 13 10">
                        <path d="M1,5 L11,5"></path>
                        <polyline points="8 1 12 5 8 9"></polyline>
                      </svg>
                    </Link>
                  </div>
                  <Modal
                    show={this.state.modal_project}
                    backdrop="static"
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header closeButton onClick={this.toggle("project")}>
                      <Modal.Title>Start a Project</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Formik
                        onSubmit={this.onProjectSubmit}
                        initialValues={{
                          name,
                          projectTitle,
                          emailAddress,
                          contactNumber,
                          organizationName,
                          city,
                          requirement,
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        enableReinitialize={true}
                        onChange={this.handleChange}
                      >
                        <Form>
                          <Row>
                            <Col md={2}>
                              <label>
                                Project Title
                                <span className="register_page_marker">*</span>
                              </label>
                            </Col>
                            <Col md={4}>
                              <Input
                                className="capitalize"
                                name="projectTitle"
                                type="text"
                                onKeyPress={(event) => {
                                  this.onKeyPressTextOnly(event);
                                }}
                                onChange={this.handleChange}
                                placeholder="Enter Project Title"
                                minLength="2"
                                maxLength="200"
                                required
                              />
                            </Col>
                            <Col md={2}>
                              <label>
                                Name
                                <span className="register_page_marker">*</span>
                              </label>
                            </Col>
                            <Col md={4}>
                              <Input
                                className="capitalize"
                                name="name"
                                type="text"
                                onKeyPress={(event) => {
                                  this.onKeyPressTextOnly(event);
                                }}
                                onChange={this.handleChange}
                                placeholder="Enter Your Name"
                                minLength="2"
                                maxLength="200"
                                required
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col md={2}>
                              <label>
                                Contact Number
                                <span className="register_page_marker">*</span>
                              </label>
                            </Col>
                            <Col md={4} className="text-center">
                              <Input
                                name="contactNumber"
                                type="text"
                                minLength="10"
                                maxLength="10"
                                placeholder="Enter Your Contact Number"
                                onChange={this.handleChange}
                                onKeyPress={(event) => {
                                  this.onKeyPressNumberOnly(event);
                                }}
                                required
                              />
                            </Col>
                            <Col md={2}>
                              <label>
                                Email Address
                                <span className="register_page_marker">*</span>
                              </label>
                            </Col>
                            <Col md={4} className="text-center">
                              <Input
                                name="emailAddress"
                                type="email"
                                onChange={this.handleChange}
                                placeholder="Enter Your Email"
                                onKeyPress={(event) => {
                                  this.onKeyPressRetrisctSomeSC(event);
                                }}
                                maxLength="200"
                                minLength="10"
                                required
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col md={2}>
                              <label>
                                Organization Name
                                <span className="register_page_marker">*</span>
                              </label>
                            </Col>
                            <Col md={4}>
                              <Input
                                className="capitalize"
                                name="organizationName"
                                type="text"
                                onKeyPress={(event) => {
                                  this.onKeyPressTextOnly(event);
                                }}
                                onChange={this.handleChange}
                                placeholder="Enter Your  Organization Name"
                                minLength="2"
                                maxLength="200"
                                required
                              />
                            </Col>
                            <Col md={2}>
                              <label>
                                City
                                <span className="register_page_marker">*</span>
                              </label>
                            </Col>
                            <Col md={4}>
                              <Input
                                className="capitalize"
                                name="city"
                                type="text"
                                onKeyPress={(event) => {
                                  this.onKeyPressTextOnly(event);
                                }}
                                onChange={this.handleChange}
                                placeholder="Enter Your City Name"
                                minLength="2"
                                maxLength="200"
                                required
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col md={10}>
                              <label>
                                Requirement
                                <span className="register_page_marker">*</span>
                              </label>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12} className="text-center">
                              <Input
                                placeholder="Enter Your Requirement"
                                name="requirement"
                                maxLength="200"
                                type="textarea"
                                rows="2"
                                onChange={this.handleChange}
                                onKeyPress={(event) => {
                                  this.onKeyPressRetrisctSomeSC(event);
                                }}
                                required
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md={2}>
                              <Button variant="outline-danger" type="submit">
                                Submit
                              </Button>
                            </Col>
                            <Col md={2}>
                              <Button
                                variant="outline-secondary"
                                type="button"
                                onClick={this.toggle("project")}
                              >
                                Cancel
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </Formik>
                    </Modal.Body>
                  </Modal>
                </div>
              </Card>
            </Col>

            <Col>
              <Card>
                <div className="embedded_projectspacing">
                  <h4 className="aboutus_fontbold">Trainings</h4>
                  <p>
                    <strong>
                      Create a Better version of yourself by being a part of the
                      training and knowledge sharing we offer!
                    </strong>
                  </p>
                  <div className="it_buttonalign">
                    <Link
                      to="/training"
                      class="cta"
                      style={{ textDecoration: "none" }}
                    >
                      <span>Training</span>
                      <svg width="13px" height="10px" viewBox="0 0 13 10">
                        <path d="M1,5 L11,5"></path>
                        <polyline points="8 1 12 5 8 9"></polyline>
                      </svg>
                    </Link>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
          <hr />
        </div> */}

        <div className="aboutus_mainspace">
          <h4 data-aos="fade-right">
            <span className="aboutus_fontbold">Success </span>
            <span>Stories </span>
            <Link to="/success-story">
              <Plus class="rounded mx-auto homepage_plussize" />
            </Link>
          </h4>
          <br />

          <ItSuccessStories data={successData} />
        </div>
        <br />
        {/*Success Modal */}
        <Modal
          show={this.state.modal_success}
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal_alert"
        >
          <Modal.Body className="modalBody">
            <div className="aboutus_textalign">
              <img
                src={successImage}
                width="8%"
                alt="ekathvainnovations.com"
              ></img>
              <br />
              <br />
              <h4 className="aboutus_textalign">
                <strong> Success! </strong>
              </h4>
              <br />
              <br />
              <h6 className="aboutus_textalign">{this.state.message}</h6>
              <br />
              <Button
                type="button"
                variant="outline-danger"
                onClick={this.toggle("success")}
              >
                OK
              </Button>
            </div>
            <br />
          </Modal.Body>
        </Modal>

        {/*Failure Modal */}
        <Modal
          show={this.state.modal_failure}
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal_alert"
        >
          <Modal.Body className="modalBody">
            <div className="aboutus_textalign">
              <img
                src={failureImage}
                width="8%"
                alt="ekathvainnovations.com"
              ></img>
              <br />
              <br />
              <h4 className="aboutus_textalign">
                <strong> Failure! </strong>
              </h4>
              <br />
              <br />
              <h6 className="aboutus_textalign">{this.state.message}</h6>
              <br />
              <Button
                type="button"
                variant="outline-danger"
                onClick={this.toggle("failure")}
              >
                OK
              </Button>
            </div>
            <br />
          </Modal.Body>
        </Modal>

        <Footer />
      </div>
    );
  }
}
export default ItServicePage;
